import { render, staticRenderFns } from "./OrganManage.vue?vue&type=template&id=4bc32060"
import script from "./OrganManage.vue?vue&type=script&lang=js"
export * from "./OrganManage.vue?vue&type=script&lang=js"
import style0 from "./OrganManage.vue?vue&type=style&index=0&id=4bc32060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports